function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBin = function SvgBin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 24412"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17710",
    d: "m18 6.733-.809 11.333a1.867 1.867 0 0 1-1.862 1.734H7.6a1.867 1.867 0 0 1-1.862-1.734L4.933 6.733M9.6 10.467v5.6m3.733-5.6v5.6m.933-9.333v-2.8A.933.933 0 0 0 13.333 3H9.6a.933.933 0 0 0-.933.933v2.8M4 6.733h14.933",
    transform: "translate(.2 1.2)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1919",
    d: "M24 24H0V0h24z",
    transform: "rotate(-90 12 12)",
    style: {
      opacity: 0.87,
      fill: "none"
    }
  })));
};

export default SvgBin;